import { getNumbersFromStr } from '../text/get-numbers-from-str';

import { TMeta } from './models';

export const isError = ({ active, dirtySinceLastSubmit, error, submitError, touched }: TMeta) => {
    if (active) return false;
    if (error) return touched;
    if (submitError) return !dirtySinceLastSubmit;

    return false;
};

export const isPhoneError = (
    { active, dirtySinceLastSubmit, error, submitError, touched }: TMeta,
    value: string
) => {
    if (getNumbersFromStr(value).length === 11 && error) {
        return active || touched;
    }
    if (error) return touched;
    if (submitError) return !dirtySinceLastSubmit;

    return false;
};
